const invitationStatus = {
  Created: 'Created',
  Sent: 'Sent',
  Accepted: 'Accepted'
};

export default invitationStatus;



// WEBPACK FOOTER //
// ./src/constants/invitation-status.js